import OEColorModel from './oe-color-model';
import {OEVersion} from '../../react-oe/oe-version';
import SafeList from '../safe-list';
import OEImplantcastColorModel from '../../components/custom/implantcast/oe-implantcast-color-model';
import OEThiemeColorModel from '../../components/custom/thieme/oe-thieme-color-model';

const defaultModel = new OEColorModel();

class OEColorHelperType {
    
    constructor(model) {
        this._model = model || this.modelForConfig(config);
        this.modelChangeListener = new SafeList();
    }

    getModel()  {
        return this._model;
    }

    setModel(model) {
        if(this._model === model)   return;
        this._model = model;
        this.modelChangeListener.forEach(listener => listener());
    }

    registerModelChangeListener(listener)   {
        if(typeof(listener) !== 'function') return;
        this.modelChangeListener.addUnique(listener);
    }

    unregisterModelChangeListener(listener)   {
        this.modelChangeListener.remove(listener);
    }

    themeColor() {
        return this._model.themeColor();
    }

    stdBackgroundColor(brightness)  {
        return this._model.stdBackgroundColor(brightness);
    }

    stdActiveBackgroundColor(brightness)  {
        return this._model.stdActiveBackgroundColor(brightness);
    }

    stdHoverBackgroundColor(brightness)  {
        return this._model.stdHoverBackgroundColor(brightness);
    }

    stdActiveHoverBackgroundColor(brightness)  {
        return this._model.stdActiveHoverBackgroundColor(brightness);
    }

    lightBackgroundColor(brightness)  {
        return this._model.lightBackgroundColor(brightness);
    }

    lightActiveBackgroundColor(brightness)  {
        return this._model.lightActiveBackgroundColor(brightness);
    }

    lightHoverBackgroundColor(brightness)  {
        return this._model.lightHoverBackgroundColor(brightness);
    }

    lightActiveHoverBackgroundColor(brightness)  {
        return this._model.lightActiveHoverBackgroundColor(brightness);
    }

    extraLightBackgroundColor(brightness)  {
        return this._model.extraLightBackgroundColor(brightness);
    }

    extraLightActiveBackgroundColor(brightness)  {
        return this._model.extraLightActiveBackgroundColor(brightness);
    }

    extraLightHoverBackgroundColor(brightness)  {
        return this._model.extraLightHoverBackgroundColor(brightness);
    }

    extraLightActiveHoverBackgroundColor(brightness)  {
        return this._model.extraLightActiveHoverBackgroundColor(brightness);
    }

    mainMenuBackgroundColor(brightness)  {
        return this._model.mainMenuBackgroundColor(brightness);
    }

    stdToolbarBackgroundColor(brightness)  {
        return this._model.stdToolbarBackgroundColor(brightness);
    }

    viewBackgroundColor(brightness)  {
        return this._model.viewBackgroundColor(brightness);
    }

    startViewBackgroundColor(brightness)  {
        return this._model.startViewBackgroundColor(brightness);
    }

    stdLabelTextColor(brightness)  {
        return this._model.stdLabelTextColor(brightness);
    }

    viewPortLabelTextColor(brightness)  {
        return this._model.viewPortLabelTextColor(brightness);
    }

    mainMenuTextColor(brightness)  {
        return this._model.mainMenuTextColor(brightness);
    }

    stdSeparatorColor(brightness)    {
        return this._model.stdSeparatorColor(brightness);
    }

    darkSeparatorColor(brightness)    {
        return this._model.darkSeparatorColor(brightness);
    }

    stdOverlayViewBackgroundColor(brightness)   {
        return this._model.stdOverlayViewBackgroundColor(brightness);
    }

    modelForConfig(config)    {
        if(config.version === OEVersion.implantcast)    {
            return new OEImplantcastColorModel();
        } else if(config.version === OEVersion.thieme)  {
            return new OEThiemeColorModel();
        } else {
            return defaultModel;
        }
    }

    updateForConfig(config)   {
        this.setModel(this.modelForConfig(config));
    }
}

export default new OEColorHelperType();